module.exports = "https://www.gc-pro.gnp.com.mx/b3aff4ac2b770117b4728fc01805ca75.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/smart-trip.png
// module id = 329
// module chunks = 0